import { mountGame } from '../render/three/game-app.js';
import { makeKlondikeSpec } from '../variants/klondike/spec.js';

const params = new URLSearchParams(location.search);
const drawCount = params.get('draw') === '3' ? 3 : 1;

const titleEl = document.querySelector('.hud h1');
if (titleEl && drawCount === 3) titleEl.textContent = 'Klondike · Draw 3';

await mountGame(makeKlondikeSpec({ drawCount }));
